import { useQueries } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { BranchDto } from '../branches/types';
import type { KitchenStationDto } from './types';

// Composes per-branch station queries into a single flat list. Used by
// the category drawer's station picker — categories aren't branch-scoped
// but stations are, so the picker needs the union across all branches
// to let the operator route to whichever station applies.

interface AllStationsResult {
  data: KitchenStationDto[];
  isLoading: boolean;
}

export function useAllKitchenStations(branches: BranchDto[]): AllStationsResult {
  const queries = useQueries({
    queries: branches.map((b) => ({
      queryKey: ['kitchen-stations', b.branchId] as const,
      queryFn: async () =>
        (
          await apiClient.get<KitchenStationDto[]>(
            `/api/kitchen/stations?branchId=${b.branchId}`,
          )
        ).data,
    })),
  });
  const isLoading = queries.some((q) => q.isLoading);
  const data = queries.flatMap((q) => q.data ?? []);
  return { data, isLoading };
}
